import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (data, fileName, tabname) => {
    if (!data?.length) return;

    // force same headers for all rows
    const headers = Object.keys(data[0]);

    const normalizedData = data.map((row) => {
        const obj = {};

        headers.forEach((key) => {
            obj[key] = row[key] ?? "-";
        });

        return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(
        normalizedData,
        {
            header: headers
        }
    );

    // set consistent width
    worksheet["!cols"] = headers.map(() => ({
        wch: 24
    }));
    
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, tabname || "Tracker");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
    });

    saveAs(blob, `${fileName}.xlsx`);
};